export type OrgOption = {
	id: string;
	name: string;
	sub?: string;
};

function asRecord(value: unknown): Record<string, unknown> | null {
	return value !== null && typeof value === "object" ? (value as Record<string, unknown>) : null;
}

function mapTenantEntry(entry: unknown): OrgOption | null {
	const rec = asRecord(entry);
	if (!rec) return null;
	const id =
		(typeof rec.tenantId === "string" && rec.tenantId) ||
		(typeof rec.id === "string" && rec.id) ||
		(typeof rec.tenant === "string" && rec.tenant) ||
		"";
	if (!id) return null;
	const name =
		(typeof rec.tenantName === "string" && rec.tenantName) ||
		(typeof rec.name === "string" && rec.name) ||
		id;
	const sub =
		(typeof rec.roleNames === "string" && rec.roleNames) ||
		(Array.isArray(rec.roles) ? rec.roles.join(", ") : undefined);
	return { id, name, sub };
}

/** Resolve tenant list from Descope BYOS screen context / form. */
export function getOrganizationsFromFlow(
	context?: Record<string, unknown>,
	form?: Record<string, unknown>
): OrgOption[] {
	const sources: unknown[] = [
		context?.userTenants,
		context?.tenants,
		context?.tenantList,
		form?.userTenants,
		form?.tenants
	];
	for (const source of sources) {
		if (!Array.isArray(source)) continue;
		const mapped = source.map(mapTenantEntry).filter((o): o is OrgOption => o !== null);
		if (mapped.length > 0) return mapped;
	}
	return [];
}
